/** The colour family (styles/_status-tones.scss) of an accounting-period status, by its label. */
export type StatusTone = 'none' | 'new' | 'progress' | 'ready' | 'review' | 'approved' | 'final' | 'filed';

const TONES: [RegExp, StatusTone][] = [
  [/no period/i, 'none'],
  [/not started|draft/i, 'new'],
  [/in (progress|preparation)/i, 'progress'],
  [/ready/i, 'ready'],
  [/under review/i, 'review'],
  [/approved/i, 'approved'],
  [/finalised/i, 'final'],
  [/submitted|filed/i, 'filed'],
];

/** The tone of a period status label ("Not Started", "Under Review", ...); null for text it does not know. */
export function statusTone(status: string | null | undefined): StatusTone | null {
  const text = status ?? '';
  return TONES.find(([pattern]) => pattern.test(text))?.[1] ?? null;
}

/** The class for a status shown as text: `status-tone status-approved`. */
export function statusToneClass(status: string | null | undefined): string {
  const tone = statusTone(status);
  return tone ? `status-tone status-${tone}` : '';
}
